























import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_customerListSearch_customers } from '@/queries/__generated__/customerListSearch';
import gql from 'graphql-tag';

const DELETE_CUSTOMER = gql`
  mutation deleteCustomer($id: ID!) {
    deleteCustomer(
      input: {
        id: $id,
      }
    ) {
      customer {
        id
      }
    }
  }
`;

@Component
export default class CustomerDeleteButton extends Vue {
  @Prop() public customer!: GQL_customerListSearch_customers;
  public DELETE_CUSTOMER = DELETE_CUSTOMER;

  public confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm(``, {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: `${this.customer.unit.name}` }),
      onConfirm: confirmMutation,
    });
  }
}
